/* istanbul ignore file */

export { HtmlParser as default } from "./HtmlParser";
